import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './en.json';
import ch from './ch.json';

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  resources: {
    en: en,
    ch: ch,
  },
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});
  
// i18n.changeLanguage("ch");
export default i18n;